import { cn } from '@/lib/utils';
import * as React from 'react';

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-full motion-safe:animate-spin size-10 border-4 border-t-4 border-bd-brand border-t-bd-brand',
          className,
        )}
        {...props}
      />
    );
  },
);

LoadingSpinner.displayName = 'LoadingSpinner';
